import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const personalInfoValidationSchema = Yup.object().shape({
    investorName: Yup.string().required('Investor name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    phone: Yup.string().required('Phone number is required'),
    address: Yup.string().required('Address is required'),
    dateOfBirth: Yup.date().required('Date of birth is required'),
    shares: Yup.number().min(100, 'Minimum 100 shares required').required('Number of shares is required'),
    amount: Yup.number().required('Amount is required'),
    paymentMethod: Yup.string().required('Payment method is required'),
});

const Step1Form = ({ handleNext, formData }) => (
    <Formik
        initialValues={{
            investorName: formData.investorName || '',
            email: formData.email || '',
            phone: formData.phone || '',
            address: formData.address || '',
            dateOfBirth: formData.dateOfBirth || '',
            shares: formData.shares || '',
            amount: formData.amount || '',
            paymentMethod: formData.paymentMethod || '',
        }}
        validationSchema={personalInfoValidationSchema}
        onSubmit={(values, { setSubmitting }) => {
            handleNext(values);
            setSubmitting(false);
        }}
    >
        {() => (
            <Form className="px-6 py-4 space-y-6">
                {/* Investor Information Section */}
                <div>
                    <h2 className="text-xl font-semibold text-purple-600 mb-4">Investor Information</h2>
                    <div className="grid grid-cols-1 gap-4">
                        <div>
                            <label htmlFor="investorName" className="block text-sm font-medium text-gray-700">Investor Name</label>
                            <Field
                                type="text"
                                name="investorName"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="investorName" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                            <Field
                                type="email"
                                name="email"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="email" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                        <div>
                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone</label>
                            <Field
                                type="tel"
                                name="phone"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="phone" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                        <div>
                            <label htmlFor="address" className="block text-sm font-medium text-gray-700">Address</label>
                            <Field
                                type="text"
                                name="address"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="address" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                        <div>
                            <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700">Date of Birth</label>
                            <Field
                                type="date"
                                name="dateOfBirth"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="dateOfBirth" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                    </div>
                </div>

                {/* Investment Details Section */}
                <div>
                    <h2 className="text-xl font-semibold text-purple-600 mb-4">Investment Details</h2>
                    <div className="grid grid-cols-1 gap-4">
                        <div>
                            <label htmlFor="shares" className="block text-sm font-medium text-gray-700">
                                Number of Shares Requested (Minimum: 100 Shares)
                            </label>
                            <Field
                                type="number"
                                name="shares"
                                min="100"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="shares" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                        <div>
                            <label htmlFor="amount" className="block text-sm font-medium text-gray-700">INR Amount</label>
                            <Field
                                type="number"
                                name="amount"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            />
                            <ErrorMessage name="amount" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                        <div>
                            <label htmlFor="paymentMethod" className="block text-sm font-medium text-gray-700">Payment Method</label>
                            <Field
                                as="select"
                                name="paymentMethod"
                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm"
                            >
                                <option value="">Select payment method</option>
                                <option value="bankTransfer">Bank Transfer</option>
                                <option value="cheque">Cheque</option>
                                <option value="dd">Demand Draft</option>
                            </Field>
                            <ErrorMessage name="paymentMethod" component="div" className="text-sm text-red-600 mt-1" />
                        </div>
                    </div>
                </div>

                {/* Next Button */}
                <div>
                    <button
                        type="submit"
                        className="w-full py-2 px-4 bg-purple-600 text-white rounded-md shadow-sm hover:bg-purple-700"
                    >
                        Next
                    </button>
                </div>
            </Form>
        )}
    </Formik>
);

export default Step1Form;
